/**
 * #605: подпись карточки тренировки без программы. «Программа не назначена» —
 * формулировка ТФА: программу составляет куратор, клиент ждёт. На тарифах без
 * куратора (Программа тренировок, Клуб) программу никто не назначит — человек
 * выбирает её сам на экране тренировок. Под старой подписью покупатель
 * «Программы тренировок» решил, что программа не подгружается, и не открыл
 * экран выбора, где его купленная программа уже ждала.
 */
export function trainingCardIdleCopy(selfManaged: boolean): { text: string; cta: string } {
  return selfManaged
    ? { text: 'Выбери программу — она уже доступна', cta: 'Выбрать программу' }
    : { text: 'Программа не назначена', cta: 'Открыть тренировки' }
}
